import React from "react";
import ReactDOM from "react-dom";
import AppWrapper from "./AppWrapper";
import CardListPage from "./components/Desktop/CardList/CardListPage";
import { RecentImagesProvider } from "./components/SPA/hooks/recentimages";
import PriceListProvider from "./components/Providers/PriceListProvider";
// @ts-ignore
const reactData = (window.reactData);
if (document.getElementById("root")) {
    ReactDOM.render(React.createElement(AppWrapper, null,
        React.createElement(PriceListProvider, null,
            React.createElement(RecentImagesProvider, null,
                React.createElement(CardListPage, { category: reactData.category || '' })))), document.getElementById("root"));
}
